import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class AuthorService {
  private authorCountSubject = new BehaviorSubject<number>(0);
  authorCount$ = this.authorCountSubject.asObservable();

  updateAuthorCount(count: number) {
    this.authorCountSubject.next(count);
  }
}
